import whatsappIcon from '@/resources/images/whatsapp_icon.svg';
import smsLogo from '@/resources/images/sms_logo.svg';
import googleRcsIcon from '@/resources/images/Google_RCS_icon.svg';
import emailIcon from '@/resources/images/email_icon.svg';

export const FIELD_TYPE = {
  NONE: "none",
  DD: "dropdown",
  DWF: "date_with_filter",
  DTWF: "datetime_with_filter",
  DDWF: "dropdown_with_filter",
  DDWS: "dropdown_with_static",
  TBWF: "textbox_with_filter"
};

export const CONDITION_TYPE = {
  TAGS: 'Tags',
  TALKED_WITH_AGENT: 'Talked with Agent',
  INTERACTED_WITH_CHANNEL: 'Interacted with Channel',
  INTERACTION_DATE: 'Interaction Date',
  INTERACTION_TIME: 'Interaction Time',
  LAST_REPLY_DATE: 'Last Reply Date',
  INTERACTED_WITH_BOT: 'Interacted with Bot',
  INTERACTION_CHANNEL: 'Interaction Channel',
  NAME: 'Name',
  EMAIL: 'Email',
  NUMBER: 'Number',
  GENDER: 'Gender',
  CUSTOM_FIELD: 'Custom field',
  INTERACTION_CHANNEL_PAGE_ID: 'Interaction Channel Page ID',
  ENGAGED_WITH_BOT_FLOW: 'Engaged with bot flow',
  DLR_STATUS: 'Broadcast delivery status',
  BROADCAST_INTERACTION_STATUS: 'Broadcast interaction status',
  MARKETING_OPT_IN_STATE: 'Marketing Opt-in Status',
}

export const KEY_CONDITION_TYPE_MAPPING = {
  LastActive: CONDITION_TYPE.INTERACTION_DATE,
  LastActiveTimestamp: CONDITION_TYPE.INTERACTION_TIME,
  user_lastreply_time: CONDITION_TYPE.LAST_REPLY_DATE,
  userReplyDate: CONDITION_TYPE.LAST_REPLY_DATE,
  platform: CONDITION_TYPE.INTERACTED_WITH_CHANNEL,
  agent_id: CONDITION_TYPE.TALKED_WITH_AGENT,
  user_name: CONDITION_TYPE.NAME,
  user_email: CONDITION_TYPE.EMAIL,
  user_mobilenumber: CONDITION_TYPE.NUMBER,
  user_gender: CONDITION_TYPE.GENDER,
  tag: CONDITION_TYPE.TAGS,
  custom_fields: CONDITION_TYPE.CUSTOM_FIELD,
  pageid: CONDITION_TYPE.INTERACTION_CHANNEL_PAGE_ID,
  bots: CONDITION_TYPE.ENGAGED_WITH_BOT_FLOW,
  tags: CONDITION_TYPE.TAGS,
  conversation_id: CONDITION_TYPE.DLR_STATUS,
  broadcast_interaction_status: CONDITION_TYPE.BROADCAST_INTERACTION_STATUS,
  marketing_opt_in_state: CONDITION_TYPE.MARKETING_OPT_IN_STATE,
}

export const channels = [
  {
    name: "WhatsApp",
    id: "whatsapp",
    img: whatsappIcon,
    selected: false,
    supported_templates: "all",
    active: true
  },
  {
    name: "GoogleRCS",
    id: "googlercs",
    img: googleRcsIcon,
    selected: false,
    supported_templates: "all",
    active: true
  },
  {
    name: "SMS",
    id: "sms",
    img: smsLogo,        
    selected: false,
    supported_templates: "buttonreply",
    active: true
  },
  {
    name: "Email",
    id: "email",
    img: emailIcon,
    selected: false,
    supported_templates: "all",
    active: true
  },
];

export const filterOperatorsMapping = {
  on: "=",
  before: "<",
  after: ">",
  "is unknown": "is null",
  is: "=",
  "isn't": "!="
};

export const filterOperatorsMappingReverse = {
  "=": "is",
  "<=": "before",
  "<": "before",
  ">=": "after",
  ">": "after",
  "!=": "isn't",
  "is null": "is unknown"
};
